import { IComponentOptions } from 'angular';

import { MonitorAttendanceCtrl } from './monitor-attendance.controller';

export const MonitorAttendanceComponent: IComponentOptions = {
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  controller: MonitorAttendanceCtrl,
  template: require('./monitor-attendance.html'),
};
